import { BrandColor, GelTheme, KiamaFontWeight, KnownColor, KnownFontSize, KnownFontWeight } from 'components/GelTheme';
import * as React from 'react';
import styled from 'styled-components';

export interface TypographyProps {
  /** The DOM element type to display this component as. Defaults to `span`. */
  as?: string | React.ComponentType;

  /** The font weight to apply to the text */
  fontWeight?: KnownFontWeight | KiamaFontWeight;

  /** The font size to apply to the text */
  fontSize?: KnownFontSize;

  /** One of the known colour aliases to render the text in. */
  color?: KnownColor | BrandColor;
}

/**
 * A helper component to allow adding typography styles as CSS properties.
 */
export const Typography = styled('span')<TypographyProps>`
  font-weight: ${(props) => (props.fontWeight ? GelTheme.fontWeight(props.fontWeight) : undefined)};
  font-size: ${(props) => (props.fontSize ? GelTheme.fontSize(props.fontSize) : undefined)};
  color: ${(props) => (props.color ? GelTheme.color(props.color) : undefined)};
`;

Typography.defaultProps = {
  as: 'span',
};
